import { GoArrowLeft } from "react-icons/go";

interface BackButtonHeaderPopUpProps {
  onClick: () => void;
  title?: string;
}

const BackButtonHeaderPopUp: React.FC<BackButtonHeaderPopUpProps> = ({
  onClick,
  title = "Come back to the previous step",
}) => {
  return (
    <button
      className="p-1.5 bg-neutral-50 rounded-full backdrop-blur-[32px] justify-center items-center flex cursor-pointer hover:bg-neutral-100 ease-in-out duration-150"
      onClick={onClick}
      title={title}
    >
      <GoArrowLeft className="w-5 h-5 fill-secondary-600" />
    </button>
  );
};

export default BackButtonHeaderPopUp;
